// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"44a65b53","455":"73841915","977":"7b343b00"}[chunkId] + ".chunk.js";
};